/**
 * @generated SignedSource<<b34f766fd9149515361d11fcf2aee07b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GroupsMenu_stream$data = {
  readonly homePanelGroup: {
    readonly id: string;
  } | null;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"HomePanelGroupsMenu_object">;
  readonly " $fragmentType": "GroupsMenu_stream";
};
export type GroupsMenu_stream$key = {
  readonly " $data"?: GroupsMenu_stream$data;
  readonly " $fragmentSpreads": FragmentRefs<"GroupsMenu_stream">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GroupsMenu_stream",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HomePanelGroupsMenu_object"
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "HomePanelGroup",
      "kind": "LinkedField",
      "name": "homePanelGroup",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "NoteStream",
  "abstractKey": null
};
})();

(node as any).hash = "b2834c4d32250622ed920b3e911457f4";

export default node;
